import { ReactNode } from "react"
import { css, cx } from "@emotion/css"

const styles = {
  root: css`
    padding-top: 0;
    padding-right: var(--spacing-xl, 24px);
    padding-bottom: var(--spacing-xl, 24px);
    padding-left: var(--spacing-xl, 24px);
  `,
  paddingTop: css`
    padding-top: var(--spacing-xl, 24px);
  `,
  center: css`
    justify-content: center;
  `,
}

export type DialogContentProps = {
  children: ReactNode
  className?: string
  center?: boolean
  paddingTop?: boolean
}

export function DialogContent(props: DialogContentProps) {
  const { children, center = false, paddingTop = false, className } = props
  const cn = cx(
    styles.root,
    { [styles.center]: center, [styles.paddingTop]: paddingTop },
    className,
  )
  return (
    <div data-dialog-content className={cn}>
      {children}
    </div>
  )
}
